export default function PhilosophyDetail({ data }) {
    if (!data?.our_philosophy) return null;

    const { left, right, description } = data.our_philosophy;

    return (
        <section className="philosophy-section">
            <div className="philosophy-left">
                <h2>
                    <span className="italic">Our</span>{" "}
                    <span className="ph_txt">Philosophy</span>
                </h2>

                {left && (
                    <img
                        src={left}
                        alt="Philosophy Detail"
                        className="philosophy-subimage"
                    />
                )}

                {description && <p>{description}</p>}
            </div>

            {right && (
                <div className="philosophy-right">
                    <img src={right} alt="Craftsman Weaving" />
                </div>
            )}
        </section>
    );
}
